"use strict";

import * as twgl from 'twgl.js'
import * as sound from './strumenti.js';
import * as strumenti from './strumenti';
import {rTComment} from "../rikis"
// import * as twgl from './twgl-full.module.js'

/*
Lista dei nomi delle pictures!!!
*/
var r_pictures = ['0885', '1058', '1044', '1202', '0953', '0864', '0999', '0961', '1065', '1016', '0816', '0822', '1024', '0970', '1019', '0865', '0812', '1006', '0868', '0956', '1026', '1048', '1101', '0874', '0993', '1046', '0798', '0902', '1067', '1205', '1045', '0808', '1213', '1020', '0950', '0890', '0988', '1199', '1209', '1207', '1063', '1031', '0971', '0990', '1203', '1185', '1196', '1040', '0952', '1039', '1032', '0954', '1008', '0921', '1099', '1014', '1096', '0849', '1023', '1012', '1195', '0908', '0941', '0989', '1091', '0965', '1194', '1021', '0980', '0982', '1053', '1052', '0947', '1211', '1015', '0880', '1071', '0978', '1064', '1212', '0966', '1054', '1191', '1005', '1184', '1010', '1092', '0824', '0923', '1192', '1009', '1034', '0853', '0917', '1098', '0963', '1062', '0863', '1197', '1057', '0967', '0814', '1100', '1038', '1059', '1095', '0991', '1030', '1003', '1210', '0936', '1069', '1068', '0948', '1094', '0862', '1004', '0981', '0962', '0977', '1186', '1047', '1000', '0875', '1037', '1002', '0968', '0959', '1013', '0805', '0955', '0867', '1042', '0905', '0821', '1055', '0907', '1029', '0944', '0969', '0942', '0845', '1072', '0964', '0844', '0927', '1188', '1017', '0976', '1018', '0983', '0871', '0929', '0992', '1049', '1200', '1025', '1028', '1206', '1061', '0998', '1033', '0832', '0809', '0897', '1097', '0850', '0883', '0960', '1050', '0859', '1204', '0979', '1035', '1193', '1066', '0911', '0891', '0985', '1001', '0925', '0958', '0984', '0994', '0914', '1051', '0826', '1201', '0894', '1060', '0975', '1208', '0997', '1027', '0986', '0802', '0987', '1011', '0972', '0933', '1198', '1007', '0856', '1093', '0996', '0870', '1056', '1043', '1070', '1077', '1189', '0995', '1036', '1187', '0974', '0877', '0918', '1041', '0834', '1022', '0973', '0901'];


/*
 * Ritorna una promise che deve essere utilizzata come getImageData(url, canvaselement).then((imageData => { mettere qui }));
 * @param {type} nx: numero elementi in orizzontale
 * @param {type} ny: numero elementi verticale
 * @param {type} dx: larghezza 
 * @param {type} dy: altezza
 * @returns {getRectangle.f|Float32Array|undefined}
 */
function getImageData(url, nx = - 1, ny = - 1, dx = 20, dy = 12) {
	return new Promise((resolve, reject) => {

		//creiamo un imagecontext che contenga i dati dell'intera immagine
		const imageCanvas = document.createElement('canvas'); //creazione elemento DOM Canvas
		const imageCtx = imageCanvas.getContext("2d"); //recupero context di immagine intera da utilizzare in seguito come texture

		//creiamo un context che contenga i dati dell'immagine scalata per recuperarne i dati in downscaling (manipolazione dei quadrati)
		const dataCanvas = document.createElement('canvas'); //creazione elemento DOM Canvas

		var ret = {}; //ritorneremo image data e canvas per un successivo utilizzo!!

		const image = new Image();
		let imageData;

		image.src = url;
		image.crossOrigin = '';
		//listener che l'immagine si è caricata
		image.onload = function() {

			//la ratio dell'immagine: se >1 più alta che larga
			let ratio = this.naturalHeight / this.naturalWidth;

			//nel caso il ridemonsionamento sia di una sola domensione o di entrambe
			if (nx === -1 || ny === -1) {
				//entrambi -1: si imposta la dimensione dei singoli pixels
				if (nx === -1 && ny === -1) {
					dataCanvas.width = this.naturalWidth;
					dataCanvas.height = this.naturalHeight;
				}
				//uno o altro 
				else {
					//nel caso l'altezza sia maggiore invertiamo la grandezza della base
					if (ratio > 1) {
						let tt = nx;
						nx = ny;
						ny = tt;
					}
					//una dimensione
					if (ny === -1 && nx !== -1) //stabilita solo altezza, width deve essere -1
					{
						dataCanvas.width = nx;
						dataCanvas.height = nx * ratio;
					} else if (ny !== -1 && nx === -1) //stabilita solo lunghezza, height deve essere -1
					{
						dataCanvas.height = ny;
						dataCanvas.width = ny / ratio;
					}
				}
			}
			//dimensioni in base alle caratteristiche
			else {
				dataCanvas.width = nx;
				dataCanvas.height = ny;
			}


			//recupero context di immagine scalata da utilizzare in seguito come dati per i quadrati
			const dataCtx = dataCanvas.getContext("2d");

			//abbiamo recuperato le dimensioni che ci interessano. Disegnamo l'immagine sul context data ridimensionato per i calcoli necessari
			dataCtx.drawImage(this, 0, 0, dataCanvas.width, dataCanvas.height);
			//e recuperiamo i dati immagine
			imageData = dataCtx.getImageData(0, 0, dataCanvas.width, dataCanvas.height);


			//ora disegnamo l'immagine sul canvas da usare come texture: immagine a grandezza originale
			imageCanvas.width = this.naturalWidth;
			imageCanvas.height = this.naturalHeight;
			imageCtx.drawImage(this, 0, 0);


			//recupero dei dati dall'immagine colore
			let iData = setFragments(imageData);



			//messa la durata dell'insieme
			//iData.duration; //200 secondi


			//			alert('allora');
			//suddivisione per fragments di colore: si recupera gli id;
			islandSearch2(iData, 0.20, 50, 2500000, .2);

			//creazione 
			//			if (rTComment)  console.log('fragments: ', iData.length, iData);


			//adattamento dimensioni immagine

			//RATIO DEL CANVAS: .5625 (formato cine, impostato sulla pagina direttamente)

			//immagine in altezza contenuta nel canvas
			if (ratio < .5625) {
				dx = 23; //larghezza massima
				dy = dx * ratio;
			} else {
				dy = 13; //altezza massima
				dx = dy / ratio;
			}

			//			if (this.naturalHeight > this.naturalWidth) //per prevenire disastri in altezza
			//			{
			//				let tt = dx;
			//				dx = dy;
			//				dy = tt;
			//			}
			//
			//
			//			if (dx === -1 && dy === -1) {
			//				dx = nx;
			//				dy = ny;
			//			} else if (dy === -1 && dx !== -1) //stabilita solo altezza, width deve essere -1
			//			{
			//				dy = dx * (this.naturalHeight / this.naturalWidth);
			//			} else if (dy !== -1 && dx === -1) //stabilita solo lunghezza, height deve essere -1
			//			{
			//				dx = dy * (this.naturalWidth / this.naturalHeight);
			//			}



			//recupero dati gls da passare agli shaders!!  si inizializza l'audio del singolo frammento anche!
			const objectData = getMeshFromPixels(iData, dx, dy);

			ret = {
				image: this,
				imageCanvas: imageCanvas,
				imageContext: imageCtx,
				dataCanvas: dataCanvas,
				dataContext: dataCtx,
				imageData: iData, //qua ci sarà anche audioContext
				objectData: objectData //i dati che saranno passati ai shaders 
			};


			// li ritorniamo come resolve della promise che utilizzerai tramite then!!
			resolve(ret);
		};
	});
}



function rand(min, max) {
	if (max === undefined) {
		max = min;
		min = 0;
	}
	return min + Math.random() * (max - min);
}

function randElement(array) {
	return array[rand(array.length) | 0];
}

/**
 * in entrata imageData da context, in uscita un object con informazioni per ogni pixel: id + centro isola
 * @param {type} imageData: l'immagine ridimensionata del context
 * @param {type} image: l'immagine originale da cui è stato preso il context
 * @returns {undefined}
 */
function setFragments(imageData) {
	/*
	 * dx, dy: width, height del novero finale di quad
	 * ox, oy: dimensioni originali dell'immagine che servono per la dimensione finale delle coordinate texture
	 * px, py: proporzioni fra le due dimensioni, da usare nel recupero delle coordinate!
	 */


	let dat = []; //contiene tutti i dati

	let dx = imageData.width;
	let dy = imageData.height;

	let np = dx * dy; //somma di pixels
	let penultimariga = np - dx; //conteggio alla penultima riga

	//pointers ai pixel. Quando oltrepassa boundary sarà -1!
	let uplt = 0; //up left pixel
	let up = 0; //up pixel
	let uprt = 0; //up right
	let rt = 0; // right pixel
	let dnrt = 0; //down right pixel
	let dn = 0; //down
	let dnlt = 0; //down left
	let lt = 0; //left pixel

	//passo 1: recuperiamo i singoli colori in forma di array di array
	let pixels = [];
	for (let i = 0; i < imageData.data.length;) {
		pixels.push([imageData.data[i++], imageData.data[i++], imageData.data[i++], imageData.data[i++]]);
	}

	//gnuplot
	//gnuplot
	let s = "";
	//gnuplot
	//gnuplot


	//per ogni pixel mettiamo i dati
	pixels.forEach(function(val, index) {

		//individuazione dei pixels limitrofi
		uplt = index - dx - 1; //up left pixel
		up = index - dx; //up pixel
		uprt = index - dx + 1; //up right
		rt = index + 1; // right pixel
		dnrt = index + dx + 1; //down right pixel
		dn = index + dx; //down
		dnlt = index + dx - 1; //down left
		lt = index - 1; //left pixel

		// xy coordinate pixel dell'immagine ridimensionata
		let x = index % dx;
		let y = parseInt(index / dx);


		//Check for image boundaries:

		if ((index + 1) % dx === 0) //resto della divisione numero pixel per lunghezza, se è zero significa che siamo all'estrema destra 
		{
			rt = dnrt = uprt = -1;
		}

		if ((index % dx) === 0) //resto della divisione della coordinata y per l'altezza, se zero indica il boundary sotto
		{
			uplt = lt = dnlt = -1;
		}

		if (index < dx) //resto della divisione numero pixel per lunghezza ad iniziare da zero, se è zero significa che siamo all'estrema sinistra 
		{
			uplt = up = uprt = -1;
		}

		if (index > penultimariga) //resto della divisione della coordinata y a partire da zero per l'altezza, se zero indica il boundary sopra
		{
			uprt = up = uplt = -1;
		}

		//Ogni pixel consiste di questi dati
		dat.push({
			x: x,
			y: y,
			col: val, //il pixel - colori rgba
			pt: [uplt, up, uprt, rt, dnrt, dn, dnlt, lt], //i riferimenti ai keys attorno al pixel: 0->up left, 1->up...
			id: -1, //L'index che conterrà i pixels simili, inizializzazione -1 per contraddistinguere gli altri!
			flag: 0 //ci serivrà per l'individuazione delle isole	
		});
		//        if (rTComment)  console.log([uplt, up, uprt, rt, dnrt, dn, dnlt, lt]);

		//gnuplot
		//gnuplot
		//                let dd = dat[dat.length - 1];
		//                s = s + dd.x + "\t" +
		//                        dd.y + "\t" +
		////              "\t0.01\t" +
		//                        dd.id + "\t" +
		//                        dd.col.r + "\t" +
		//                        dd.col.g + "\t" +
		//                        dd.col.b +
		//                        "\n";
		//gnuplot
		//gnuplot


	});

	//DEBUGGG!
	//DEBUGGG!
	//            sendFile("z.dat", s);
	//DEBUGGG!
	//DEBUGGG!

	//si ritorna l'elaborazione dei pixel immagine per successivo frazionamento!
	/**
	(dati: array di oggetti 
		{	
			x: x,
			y: y,
			col: val, //il pixel - colori rgba
			pt: [uplt, up, uprt, rt, dnrt, dn, dnlt, lt], //i riferimenti ai keys attorno al pixel: 0->up left, 1->up...
			id: -1, //L'index che conterrà i pixels simili, inizializzazione -1 per contraddistinguere gli altri!
			flag: 0 //ci serivrà per l'individuazione delle isole	
		} */
	const ret = {
		width: dx,
		height: dy,
		length: dat.length, //numero di pixels!
		dati: dat
	}
	//    if (rTComment)  console.log(ret);
	return ret;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * in entrata oggetto dati (colori, coordinate, id)
 * @param {type} iData : oggetto immagine in entrata
	{
		width: dx,
		height: dy,
		length: dat.length, //numero di pixels!
		dati: array di oggetti
				{
					x: x,
					y: y,
					col: val, //il pixel - colori rgba
					pt: [uplt, up, uprt, rt, dnrt, dn, dnlt, lt], //i riferimenti ai keys attorno al pixel: 0->up left, 1->up...
					id: -1, //L'index che conterrà i pixels simili, inizializzazione -1 per contraddistinguere gli altri!
					flag: 0 
				}
	}
 * @param {type} NMin : min numero elementi per insieme di punti limitrofi
 * @param {type} NMax : max numero elementi
 * @param {type} tolleranza : tolleranza colori in percenti 0->1; Ogni colore deve essere nel range stabilito:
 * tolleranza/2<r<tolleranza/2 tolleranza/2<g<tolleranza/2  tolleranza/2<b<tolleranza/2
 * @returns {undefined}
 */
function islandSearch2(iData, tolleranza, NMin = 10, NMax = 500, zradius = 0.2) {

	////////////////////////////////////////////////////////
	//INNER FUNCTIONS
	//variabile esterna per il conteggio NMax
	const N = { n: 0, nmax: NMax, nmin: NMin };
	const w = iData.width;
	const h = iData.height;

	//calcola la distanza fra i due pixels
	function pixDistance(p1, p2) {
		let x = (p2.x - p1.x) / w;
		let y = (p2.y - p1.y) / h;
		return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
	}

	/*
	in entrata array di pixels con una certa caratteristica, in uscita lista dei pixel limitrofi con le stesse caratterstiche
	segna i pixels con l'id e la flag parametro
	refpix: pixel di riferimento per colore e distanza
	*/
	function getPixels(plist, refpix, id, flag, tz, N, radius) {
		let ret = [];

		//pixels della lista in entrata
		plist.forEach((pp, i) => {
			//contraddistinguiamo per primo il pix in questione
			pp.id = id;
			pp.flag = flag;

			//individuazione pixels limitrofi in base alla loro posizione; pt=array di indici dei pixels intorno
			pp.pt.forEach((pid, i) => { //pid: array id del pixel
				let pix = iData.dati[pid]; //individuato il pixel limitrofo
				if (typeof pix !== "undefined") { //a meno che non sia inesistente...
					if (N.n < N.nmax) { //controllo che siamo nei limiti del numero di pixels consentiti
						//se il pixel non è stato scansionato, non era già stato scelto e rientra nei parametri
						let t = pixDistance(refpix, pix);
						//						if (t>0) if (rTComment)  console.log(t);
						if (pix.flag != flag && pix.id == -1 && similar(refpix.col, pix.col, tz * (1 - (t / radius))) && t <= radius) {
							pix.id = id; //il pixel è stato scelto
							ret.push(pix);
							N.n += 1;
						}
						pix.flag = flag; //il pixel è stato scansionato; non sarà più appetibile
					}

				}
			});
		});
		return ret;
	}
	//INNER FUNCTIONS
	////////////////////////////////////////////////////////

	//pixel idis, per contraddistinguere le islands in seguito
	let id = 0;
	//pixel flags, per contraddistinguere in seguito i pixels scansionati
	let flag = 1;
	//la lista pixels

	const pixels = iData.dati;

	//per ogni pixel eseguiremo la ricerca dei limitrofi. Indichiamo p0 come livello base etc.
	pixels.forEach(function(p0, i0) {

		//se il pixel non è già stato scelto o elaborato si procede
		if (p0.id == -1) {
			let p = [p0];

			let toll = tolleranza;

			do { //controllo numero minimo di pixels
				//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
				//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
				do {
					p = getPixels(p, p0, id, flag, toll, N, zradius);
				} while (p.length >= 1 && N.n < N.nmax); //ripetiamo finchè non c'è almeno un pixel nella lista e meno di quelli max richiesti
				//---------------------------------------------------------------
				if (toll <= .8 && N.n <= N.nmin) {
					//resettiamo i flag e l'id dei pixel fin'ora scelti
					p.forEach((pix, k) => {
						pix.id = -1;
						pix.flag = 0;
					});
					toll += 0.1; //aumentiamo il grado di tolleranza
					N.n = 0; //resettiamo il numero di pixel scelti
				}
				//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
				//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

			} while (toll < .5 && N.n < N.nmin); //continua finchè non è stato raggiunto il numero minimo OPPURE la tolleranza è magggiore di 0.5
			// Passaggio avanti e reset
			flag++;
			id++;
			N.n = 0;
		}
	});
	if (rTComment)  console.log('Islands: ' + id);
}
///////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////



/**
 * La funzione prendendo i dati aggiunge ad ogni pixel quatrro pixels che delimitano un quadrato, 
 * il centro oggetto e centro quad. i dati in entrata sono quelli sopra.
Qua inizailizzazioni varie, anche dei suoni
@param {type} iData : oggetto immagine in entrata
	{
		width: dx,
		height: dy,
		length: dati.length, //numero di pixels!
		dati: array di oggetti
				{
					x: x,
					y: y,
					col: val, //il pixel - colori rgba
					pt: [uplt, up, uprt, rt, dnrt, dn, dnlt, lt], //i riferimenti ai keys attorno al pixel: 0->up left, 1->up...
					id: -1, //L'index che conterrà i pixels simili, inizializzazione -1 per contraddistinguere gli altri!
					flag: 0 
				}
	}

 *  
 * @param {type} d : dati in entrata (valori dei pixel image data: colore, posizione, appartenenza ad oggetto)
 * @param {type} h : altezza finale
 * @param {type} w : larghezza finale
 * @returns {Array|getFragmentsFromObjectBasedOnIDs.o}
 */
function getMeshFromPixels(iData, w, h) {

	let ret = {
		oggetti: [], //oggetti/attributi per shaders!
		islands: {}, //statistiche oggetto
		omatrix: twgl.m4.identity(), //matrice per spostamenti, rotazioni etc. dell'intero oggetto (centro sarà il oCenter)
		qmatrix: twgl.m4.identity(), //matrice per  spostamenti, rotazioni etc. del quad. (centro sarà il qcenter)
		wmatrix: twgl.m4.identity(), //matrice di spostamento rispetto al mondo: spostamento dell'intero oggetto con centro 0,0,0
		maxnelements: 0, //massimo numero di elementi per fragment
		minnelements: 0 //minimo numero di elementi per fragment
	}; //ritorno di dati gls

	/////////////
	/////////////

	let v3 = twgl.v3; //funzioni vettore

	let dx = iData.width; //larghezza, altezza in elementi/pixels/vertices
	let dy = iData.height;

	/**diagonale del quadrato dati*/
	let data_diagonal = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));

	/**diagonale dimensioni - distanza w/h  immagine*/
	let image_diagonal = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2));

	//proporzioni da utilizzare nel posizionamento dei singoli vertici!
	let px = (w / dx);
	let py = (h / dy);

	let hlw = (w) * .5; //mezza lunghezza oggetto finale
	let hlh = (h) * .5; //mezza altezza oggetto finale

	/////////////
	/////////////

	let id = [];	// - attributo contenente l'id dell'isola

	//distanza massima pixel->centro isola	
	let maxDistance = 0;

	//---------------------------------------------------------------------


	/**ATTRIBUTI AGGIUNTIVI */
	/**ATTRIBUTI - values per pixel */
	let V1 = []; //varie 1: 	
	//	[0]: colore del pixel: r 
	//	[1]: colore del pixel: g 
	//	[2]: colore del pixel: b 
	//	[3]: colore del pixel: grey
	let V2 = []; //verie 2:
	//	[0]: colore bright del pixel	
	//	[1]: colore dark del pixel	
	//	[2]: distanza del pixel dal centro dell'isola	
	//	[3]: distanza normalizzata dal centro isola
	//	let V3 = []; //nrect Boundary dell'isola: [x0,y0,x1,y1]
	/**ATTRIBUTI */
	/**ATTRIBUTI */

	//la texture che avrà i dati all'interno. width= 6 vec4
	var texf1 = [];
	//			[0]						//numero di elementi 
	//			[1,2,3] 				//centro isola (x,y,z)
	//			//4
	//			[4,5]		 			//centro isola in texture coordinate
	//			[6,7] 					//posizione relativa x, posizione relativa y,
	//			//8 
	//			[8,9,10,11]				//Medie colore, r,g,b,grey
	//			//12
	//			[12,13]					//medie Bright,Dark
	//			//14
	//			[14],		 		//proporzione numero elementi dell'isola vs. oggetto intero
	//			[15], 				//id normalizzato (da 0->1)
	//			//16
	//			[16] beginSeconds / e.wholeDuration,		//inizio normalizzato
	//			[17] endSeconds / e.wholeDuration,		//fine normalizzata
	//			[18] normalizedNumberOfElements / e.wholeDuration, //durata normalizzata
	//			0	//reserved	
	//			//20
	var texf2 = [];
	var texf3 = [];

	//-------------------------------------------------------------------------------------------
	//-------------------------------------------------------------------------------------------

	/*
	comprende i dati dell'isola (col[id isola]) per calcolare
	{
		col[3] - media singoli colori isola (r,g,b,grey)
		ocenter - centro quadrato isola
		texoc - centro texture isola
		eln - numero di elementi 
	} 
	*/
	let islandStats = [];
	let NN = 0;

	//minimo e massimo numero di elementi in tutte le isole
	let minmaxNumberOfElements = [10000, 0];


	/**Dati globali */
	let globalColor = {
		r: 0,
		g: 0,
		b: 0,
		d: 0,
		colorComponent: [] //componenti del colore
	}


	/**IDATI (pixel singolo) FOR EACH */
	/**IDATI (pixel singolo) FOR EACH */
	iData.dati.forEach(function(p, key) {

		//se non esiste ancora l'oggetto inizializziamo l'oggetto che conterrà i calcoli per centri, medie etc.
		if (typeof islandStats[p.id] === 'undefined') {
			islandStats[p.id] = {
				col: [0, 0, 0, 0], //somma colori e grey
				minmaxbright: [1, 0], //minimo e massimo bright
				minmaxdark: [1, 0], //minimo e massimo dark NORMALIZZATI
				brightdark: [0, 0], //media bright e dark NORMALIZZATI
				db: [0, 0],  //somma valori dark-bright 
				ocenter: [0, 0, 0],  //centro oggetto
				texoc: [0, 0], //centro oggetto texture
				nrect: [1, 1, 0, 0], //bounding box dell'isola in coordinate normalizzate!
				orect: [w, h, 0, 0], //bounding box isola NON normalizzato - NON TIENE CONTO DELLA COORDINATA Z
				not_adjusted_center: [0, 0], //centro oggetto senza la trasposizione hox,hoy
				eln: 0, //numero elementi dell'isola
				normid: 0 //id normalizzato dell'isola
			};
		}

		// x y coordinate dell'immagine
		let x = p.x;
		let y = p.y;

		//PX,PY : grandezza oggetto calcolate a monte!
		let ocx = (x) * (px); //posizioni non centrate a 0,0
		let ocy = (y) * (py);

		//coordinate pixel aggiustate in base a w e h. Spostate per centrare l'oggetto 
		//hlw, hlyh metà grandezza, per centrare oggetto a 0,0,0 
		let cx = ocx - hlw;
		let cy = ocy - hlh;


		//COSTRUZIONE ATTRIBUTI
		//COSTRUZIONE ATTRIBUTI
		//posizioni del singlo pixel
		p.pos = [cx, -cy, 0];

		//altri due pixels che permetteranno di calcolare la normale direttamente nello shader 
		p.next1 = [cx + .1, -cy, 0];
		p.next2 = [cx, -cy + .1, 0];

		/**
		ELABORAZIONE IN SEGUITO: Distanza pixel->centro isola
		ELABORAZIONE IN SEGUITO: Distanza pixel->centro isola
		
		x,y,z: posizione - centro isola
		w: distanza
		 */
		p.distpos = [];

		//norm
		p.norm = [0, 0, 1];


		//ECCO QUA TUTTI GLI ID: id[offset pixel].id=l'id dell'isola per ogni singolo pixel!!
		//	id[key] = p.id;	// - id dell'isola

		/**TEXTURES COORDINATES */
		let texx = (x) / (dx - 1);
		let texy = (y) / (dy - 1);

		p.tex = [
			texx, texy
		];	// - coordinata texture

		/**TEXTURES */

		//varie RICORDATI DI MOLTIPLICARLE x 4 per assegnarle ad ogni pixel in caso di attributo!
		p.normColor = [];
		p.normColor[0] = p.col[0] / 255; //RED normalizzati 0->1 
		p.normColor[1] = p.col[1] / 255; //GREEN
		p.normColor[2] = p.col[2] / 255; //BLUE
		p.normColor[3] = (p.normColor[0] + p.normColor[1] + p.normColor[2]) / 3; //GREY

		//calcolo bright/dark
		let bright = 0; let dark = 100000;

		if (p.normColor[0] > bright) bright = p.normColor[0]; //scegli più luminoso fra vr 
		if (p.normColor[1] > bright) bright = p.normColor[1]; //scegli più luminoso fra vr 
		if (p.normColor[2] > bright) bright = p.normColor[2]; //scegli più luminoso fra vr 
		if (p.normColor[0] < dark) dark = p.normColor[0]; //scegli più scuro fra vr 
		if (p.normColor[1] < dark) dark = p.normColor[1]; //scegli più scuro fra vr
		if (p.normColor[2] < dark) dark = p.normColor[2]; //scegli più scuro fra vr

		p.normBrightDark = [];
		p.normBrightDark[0] = bright;		//- array [4] che contiene: bright; dark; distanza dal centro oggetto; numero di elementi dell'isola;
		p.normBrightDark[1] = dark;		//- array [4] che contiene: bright; dark; distanza dal centro oggetto; numero di elementi dell'isola;

		//END COSTRUZIONE ATTRIBUTI
		//END COSTRUZIONE ATTRIBUTI


		//GLOBAL COLOR!!
		globalColor.r += p.normColor[0];
		globalColor.g += p.normColor[1];
		globalColor.b += p.normColor[2];
		globalColor.d += p.normColor[3];


		//		pos.push(...pix); 	// - coordinata xy del pixel
		//		norm.push(...nr); 	// - normale pixel


		//---------------------------------------------------------------------

		//CUMULO DEI DATI PER MEDIE
		//CUMULO DEI DATI PER MEDIE

		//colri: (r,g,b,grey) da dividere per nuemro di elementi
		for (let iz = 0; iz < 4; iz++) {
			islandStats[p.id].col[iz] += p.normColor[iz]; //colori, grey per le medie
		}
		islandStats[p.id].db[0] += p.normBrightDark[0]; //bright, dark per le medie
		islandStats[p.id].db[1] += p.normBrightDark[1]; //bright, dark per le medie

		//Centro gravità oggetto: somma di tutti gli elementi diviso per numero
		//ocenter.z sarà in ogni caso 0 qua, da aggiungere in seguito!
		islandStats[p.id].ocenter[0] += cx;
		islandStats[p.id].ocenter[1] += cy;

		islandStats[p.id].texoc[0] += texx;
		islandStats[p.id].texoc[1] += texy;

		//numero elementi dell'isola
		islandStats[p.id].eln++;

		//CENTRI QUADRATO E TEXTURE
		//CENTRI QUADRATO E TEXTURE
		//centro oggetto non trasposto hox hoy
		islandStats[p.id].not_adjusted_center[0] += ocx;
		islandStats[p.id].not_adjusted_center[1] += ocy;

		//calcolo bounding nrect isola NON normalizzato
		if (islandStats[p.id].orect[0] > ocx) islandStats[p.id].orect[0] = ocx;  //minx
		if (islandStats[p.id].orect[1] > ocy) islandStats[p.id].orect[1] = ocy;  //miny
		if (islandStats[p.id].orect[2] < ocx) islandStats[p.id].orect[2] = ocx;  //maxx
		if (islandStats[p.id].orect[3] < ocy) islandStats[p.id].orect[3] = ocy;  //maxy

		if (islandStats[p.id].nrect[0] > texx) islandStats[p.id].nrect[0] = texx;  //minx
		if (islandStats[p.id].nrect[1] > texy) islandStats[p.id].nrect[1] = texy;  //miny
		if (islandStats[p.id].nrect[2] < texx) islandStats[p.id].nrect[2] = texx;  //maxx
		if (islandStats[p.id].nrect[3] < texy) islandStats[p.id].nrect[3] = texy;  //maxy


		//END CENTRI QUADRATO E TEXTURE
		//END CENTRI QUADRATO E TEXTURE


		//END CUMULO DEI DATI PER MEDIE
		//END CUMULO DEI DATI PER MEDIE

	});
	/**END IDATI (pixel singolo) FOR EACH */
	/**END IDATI (pixel singolo) FOR EACH */

	//GLOBALCOLOR
	//GLOBALCOLOR
	let DL = iData.dati.length;

	globalColor.r /= DL;
	globalColor.g /= DL;
	globalColor.b /= DL;
	globalColor.d /= DL; //grey

	/**
	avrà una semplice serie di
	{
		c:"r",
		p: posizione (r:0 g:1...)
		n: (numero di prime posizioni)
	}
 */
	globalColor.dominant = [
		{ c: 'r', p: 0, n: 0 },
		{ c: 'g', p: 1, n: 0 },
		{ c: 'b', p: 2, n: 0 },
		{ c: 'c', p: 3, n: 0 },
		{ c: 'm', p: 4, n: 0 },
		{ c: 'y', p: 5, n: 0 },
		{ c: 'd', p: 6, n: 0 }, //grey - Dark
	];


	//RED
	//calcolo di quanto si discostano le componenti dal colore? Maggiore la deviazione, più diverso dal colore! 0: purissimo, >1: assente
	let cal = 1 - (globalColor.g + globalColor.b);
	globalColor.colorComponent.push({
		col: 'r',
		num: 0, //valore che indicherà numericamente il colore
		dev: cal, //scostamento dal colore
		val: globalColor.r,
		minmaxdev: [cal, cal],  //Massimo e minimo dev per i colori delle island
		minmaxval: [globalColor.r, globalColor.r], //massimo e minimo val per i colori delle islands
	});
	//GREEN
	cal = 1 - (globalColor.r + globalColor.b);
	globalColor.colorComponent.push({
		col: 'g',
		num: 1, //valore che indicherà numericamente il colore
		dev: cal, //scostamento dal colore
		val: globalColor.g,
		minmaxdev: [cal, cal],
		minmaxval: [globalColor.r, globalColor.r],
	});
	//BLUE
	cal = 1 - (globalColor.r + globalColor.g);
	globalColor.colorComponent.push({
		col: 'b',
		num: 2, //valore che indicherà numericamente il colore
		dev: cal, //scostamento dal colore
		val: globalColor.b,
		minmaxdev: [cal, cal],
		minmaxval: [globalColor.r, globalColor.r],

	});
	//CYAN
	let ccc = ((globalColor.b + globalColor.g) / 2); //valore componente cyan
	cal = 1 - (Math.abs(globalColor.b - globalColor.g) + globalColor.r); //Di quanto si discosta il colore??
	globalColor.colorComponent.push({
		col: 'c',
		num: 3, //valore che indicherà numericamente il colore
		dev: cal, //scostamento dal colore
		val: ccc,
		minmaxdev: [cal, cal],
		minmaxval: [ccc, ccc],

	});
	//MAGENTA
	ccc = ((globalColor.r + globalColor.b) / 2);
	cal = 1 - (Math.abs(globalColor.r - globalColor.b) + globalColor.g); //Di quanto si discosta il colore??
	globalColor.colorComponent.push({
		col: 'm',
		num: 4, //valore che indicherà numericamente il colore
		dev: cal, //scostamento dal colore
		val: ccc,
		minmaxdev: [cal, cal],
		minmaxval: [ccc, ccc],
	});
	//YELLOW
	ccc = ((globalColor.r + globalColor.g) / 2);
	cal = 1 - (Math.abs(globalColor.r - globalColor.g) + globalColor.b); //Di quanto si discosta il colore??
	globalColor.colorComponent.push({
		col: 'y',
		num: 5, //valore che indicherà numericamente il colore
		dev: cal, //scostamento dal colore
		val: ccc,
		minmaxdev: [cal, cal],
		minmaxval: [ccc, ccc],
	});
	//GREY
	ccc = ((globalColor.r + globalColor.g + globalColor.b) / 3);
	cal = 1 - (Math.abs(globalColor.r - globalColor.g) + Math.abs(globalColor.r - globalColor.b) + Math.abs(globalColor.g - globalColor.b)); //Di quanto si discosta il colore??
	globalColor.colorComponent.push({
		col: 'd',
		num: 6, //valore che indicherà numericamente il colore
		dev: cal, //scostamento dal colore
		val: ccc,
		minmaxdev: [cal, cal],
		minmaxval: [ccc, ccc],
	});

	/**Sortiamo in base a percentule */
	//DOPO AVER FATTO I minmax DELLE ISOLE
	//	globalColor.colorComponent.sort((a, b) => b.dev - a.dev);


	//END GLOBALCOLOR
	//END GLOBALCOLOR


	//CALCOLO MEDIE , CENTRI OGGETTO IMPLEMENTAZIONE islandStats AUDIO
	//CALCOLO MEDIE , CENTRI OGGETTO IMPLEMENTAZIONE islandStats AUDIO

	let idnum = islandStats.length; //numero isole;

	/**Aggiungiamo la texture dati base per le singole isole  */
	window.texData = Array(islandStats.length * 4).fill(0, 0);

	//	if (rTComment)  console.log('texData length 1', window.texData.length);


	/**TEMPCALCC CALCOLO MEDIE*/
	/**TEMPCALCC CALCOLO MEDIE*/
	islandStats.forEach((e, k) => {

		//EXTERNAL
		//EXTERNAL

		//calcolo mmassimo e minimo numero elementi assoluto
		if (e.eln < minmaxNumberOfElements[0]) minmaxNumberOfElements[0] = e.eln;
		if (e.eln > minmaxNumberOfElements[1]) minmaxNumberOfElements[1] = e.eln;

		//EXTERNAL
		//EXTERNAL


		//ID ISOLA!!
		e.id = k;

		//		if (rTComment)  console.log(e.nrect);

		for (let i = 0; i < 4; i++) {
			e.col[i] /= e.eln; //calcolate le medie colori, grey
		}
		e.db[0] /= e.eln; //calcolate le medie  bright, dark
		e.db[1] /= e.eln; //calcolate le medie  bright, dark

		e.ocenter[0] = (e.ocenter[0] / e.eln);  //centro gravità isola positions
		e.ocenter[1] = -(e.ocenter[1] / e.eln);
		e.ocenter[2] = 0; //resta 0;

		e.texoc[0] /= e.eln; //centro gravità isola texture
		e.texoc[1] /= e.eln;

		//centro immagine non trasposta hox hoy
		e.not_adjusted_center[0] /= e.eln;
		e.not_adjusted_center[1] /= e.eln;

		//aggiustamento rect in base alla centratura immagine a 0,0!!
		e.orect[0] = (e.orect[0] - hlw);
		e.orect[2] = (e.orect[2] - hlw);
		e.orect[1] = -(e.orect[1] - hlh);
		e.orect[3] = -(e.orect[3] - hlh);

		//		//ordiniamo la coppia per grandezza
		//		if (e.orect[2]<e.orect[0]){
		//			let tt=e.orect[0];
		//			e.orect[0]=e.orect[2];
		//			e.orect[2]=tt;
		//		}
		//		if (e.orect[3]<e.orect[1]){
		//			let tt=e.orect[1];
		//			e.orect[3]=e.orect[1];
		//			e.orect[1]=tt;
		//		}

		//PARTE DEDICATA ALLE STATISTICHE E INIZIALIZZAZIONE AUDIO


		//ci servirà per contraddistinguere la scelta o meno dell'oggetto, per ora nell'audio
		e.chosen = false;

		//SI INTENDE da 0->1 quindi relativi
		e.length = e.eln / iData.length; //indica proporzione di quadrati dell'isola vs. oggetto intero

		e.normid = k / idnum; //id come valore da 0->1 (normalizzazione in seno al numero islands!)

		e.position = [e.not_adjusted_center[0] / w, e.not_adjusted_center[1] / h]; //posizione relativa all'immagine, da 0->1

		//colore componente (r,g,b) - si sceglie il massimo delle medie colori, 
		//ritorna un array ['colore',value']
		//Da qua: https://stackoverflow.com/questions/27376295/getting-key-with-the-highest-value-from-object
		//		let obj = { 0: e.col[0], 1: e.col[1], 2: e.col[2] };
		//		e.colorComponent = Object.entries(obj).reduce((a, b) => obj[a[0]] > obj[b[0]] ? a : b);

		//distanza massima dal centro oggetto! da calcolarsi in seguito
		e.maxDistFromCenter = 0;

		/**
		[0] ->Red
		[1] ->Green
		[2] ->Blue
		[3] ->Yellow (r+g)/2
		[4] ->Magenta (r+b)/2
		[5] ->Cyan (g+b)/2
		[6] ->Grey (r+b+g)/3
		
		 */
		e.colorComponent = [];

		//RED
		cal = 1 - (e.col[1] + e.col[2]);
		e.colorComponent.push({
			col: 'r',
			num: 0, //valore che indicherà numericamente il colore
			dev: cal, //scostamento dal colore
			val: e.col[0], //valore assoluto!
		});
		if (globalColor.colorComponent[0].minmaxdev[0] > cal) globalColor.colorComponent[0].minmaxdev[0] = cal; //percentuale minima 
		if (globalColor.colorComponent[0].minmaxdev[1] < cal) globalColor.colorComponent[0].minmaxdev[1] = cal; //percentuale massima 
		if (globalColor.colorComponent[0].minmaxval[0] > e.col[0]) globalColor.colorComponent[0].minmaxval[0] = e.col[0]; //valore minimo 
		if (globalColor.colorComponent[0].minmaxval[1] < e.col[0]) globalColor.colorComponent[0].minmaxval[1] = e.col[0]; //valore massimo 
		//GREEN
		cal = 1 - (e.col[0] + e.col[2]);
		e.colorComponent.push({
			col: 'g',
			num: 1, //valore che indicherà numericamente il colore
			dev: cal, //scostamento dal colore
			val: e.col[1],
		});
		if (globalColor.colorComponent[1].minmaxdev[0] > cal) globalColor.colorComponent[1].minmaxdev[0] = cal; //percentuale minima 
		if (globalColor.colorComponent[1].minmaxdev[1] < cal) globalColor.colorComponent[1].minmaxdev[1] = cal; //percentuale massima 
		if (globalColor.colorComponent[1].minmaxval[0] > e.col[1]) globalColor.colorComponent[1].minmaxval[0] = e.col[1]; //valore minimo 
		if (globalColor.colorComponent[1].minmaxval[1] < e.col[1]) globalColor.colorComponent[1].minmaxval[1] = e.col[1]; //valore massimo 
		//BLUE
		cal = 1 - (e.col[0] + e.col[1]);
		e.colorComponent.push({
			col: 'b',
			num: 2, //valore che indicherà numericamente il colore
			dev: cal, //scostamento dal colore
			val: e.col[2],
		});
		if (globalColor.colorComponent[2].minmaxdev[0] > cal) globalColor.colorComponent[2].minmaxdev[0] = cal; //percentuale minima 
		if (globalColor.colorComponent[2].minmaxdev[1] < cal) globalColor.colorComponent[2].minmaxdev[1] = cal; //percentuale massima 
		if (globalColor.colorComponent[2].minmaxval[0] > e.col[2]) globalColor.colorComponent[2].minmaxval[0] = e.col[2]; //valore minimo 
		if (globalColor.colorComponent[2].minmaxval[1] < e.col[2]) globalColor.colorComponent[2].minmaxval[1] = e.col[2]; //valore massimo 
		//CYAN
		ccc = (e.col[2] + e.col[1]) / 2;
		cal = 1 - (Math.abs(e.col[1] - e.col[2]) + e.col[0]); //Di quanto si discosta il colore??
		e.colorComponent.push({
			col: 'c',
			num: 3, //valore che indicherà numericamente il colore
			dev: cal, //scostamento dal colore
			val: ccc,
		});
		if (globalColor.colorComponent[3].minmaxdev[0] > cal) globalColor.colorComponent[3].minmaxdev[0] = cal; //percentuale minima 
		if (globalColor.colorComponent[3].minmaxdev[1] < cal) globalColor.colorComponent[3].minmaxdev[1] = cal; //percentuale massima 
		if (globalColor.colorComponent[3].minmaxval[0] > ccc) globalColor.colorComponent[3].minmaxval[0] = ccc; //valore minimo 
		if (globalColor.colorComponent[3].minmaxval[1] < ccc) globalColor.colorComponent[3].minmaxval[1] = ccc; //valore massimo 
		//MAGENTA
		ccc = (e.col[0] + e.col[2]) / 2;
		cal = 1 - (Math.abs(e.col[0] - e.col[2]) + e.col[1]); //Di quanto si discosta il colore??
		e.colorComponent.push({
			col: 'm',
			num: 4, //valore che indicherà numericamente il colore
			dev: cal, //scostamento dal colore
			val: ccc,
		});
		if (globalColor.colorComponent[4].minmaxdev[0] > cal) globalColor.colorComponent[4].minmaxdev[0] = cal; //percentuale minima 
		if (globalColor.colorComponent[4].minmaxdev[1] < cal) globalColor.colorComponent[4].minmaxdev[1] = cal; //percentuale massima 
		if (globalColor.colorComponent[4].minmaxval[0] > ccc) globalColor.colorComponent[4].minmaxval[0] = ccc; //valore minimo 
		if (globalColor.colorComponent[4].minmaxval[1] < ccc) globalColor.colorComponent[4].minmaxval[1] = ccc; //valore massimo 
		//YELLOW
		ccc = (e.col[0] + e.col[1]) / 2;
		cal = 1 - (Math.abs(e.col[0] - e.col[1]) + e.col[2]); //Di quanto si discosta il colore??
		e.colorComponent.push({
			col: 'y',
			num: 5, //valore che indicherà numericamente il colore
			dev: cal, //scostamento dal colore
			val: ccc,
		});
		if (globalColor.colorComponent[5].minmaxdev[0] > cal) globalColor.colorComponent[5].minmaxdev[0] = cal; //percentuale minima 
		if (globalColor.colorComponent[5].minmaxdev[1] < cal) globalColor.colorComponent[5].minmaxdev[1] = cal; //percentuale massima 
		if (globalColor.colorComponent[5].minmaxval[0] > ccc) globalColor.colorComponent[5].minmaxval[0] = ccc; //valore minimo 
		if (globalColor.colorComponent[5].minmaxval[1] < ccc) globalColor.colorComponent[5].minmaxval[1] = ccc; //valore massimo 
		//GREY
		//media colori meno max differenza
		ccc = ((e.col[0] + e.col[1] + e.col[2]) / 3);
		cal = 1 - (Math.abs(e.col[0] - e.col[1]) + Math.abs(e.col[0] - e.col[2]) + Math.abs(e.col[1] - e.col[2])); //Di quanto si discosta il colore??
		e.colorComponent.push({
			col: 'd',
			num: 6, //valore che indicherà numericamente il colore
			dev: cal, //scostamento dal colore
			val: ccc,
		});
		if (globalColor.colorComponent[6].minmaxdev[0] > cal) globalColor.colorComponent[6].minmaxdev[0] = ccc; //percentuale minima 
		if (globalColor.colorComponent[6].minmaxdev[1] < cal) globalColor.colorComponent[6].minmaxdev[1] = ccc; //percentuale massima 
		if (globalColor.colorComponent[6].minmaxval[0] > ccc) globalColor.colorComponent[6].minmaxval[0] = ccc; //valore minimo 
		if (globalColor.colorComponent[6].minmaxval[1] < ccc) globalColor.colorComponent[6].minmaxval[1] = ccc; //valore massimo 

		/**Sortiamo i colori dell'isola in base a deviazione dal colore */
		e.colorComponent.sort((a, b) => b.dev - a.dev);

		/**incrementiamo il numero dominant del colore in prima posizione!! */
		globalColor.dominant[e.colorComponent[0].num].n++;

		//	if (e.colorComponent[0].col=="m" || e.colorComponent[0].col=="y" || e.colorComponent[0].col=="c" || e.colorComponent[0].col=="d")	

		//		if (rTComment)  console.log('color ', k, e.col, e.colorComponent, globalColor.colorComponent);


		//bright,dark of average
		e.bd = [...e.db];

		//		if (rTComment)  console.log("Object n: "+k+" el.num: "+e.eln, e.ocenter, e.position);

	});
	/**END TEMPCALCC CALCOLO MEDIE*/
	/**END TEMPCALCC CALCOLO MEDIE*/


	/**ULTIMI CALCOLI PER PIXEL: distanze etc.*/

	iData.dati.forEach(function(p, key) {
		p.distpos = []; //dati distanza pixel->centro oggetto
		//distanze dal centro del singolo pixel, per ogni terna

		//vettore pixel->centro isola
		let cen = v3.subtract(p.pos, islandStats[p.id].ocenter);
		//distanza pixel dal centro isola
		let dis = v3.distance(p.pos, islandStats[p.id].ocenter);

		//vettore centro isola->pos
		p.distpos.push(...cen);

		//distanza pixel dal centro oggetto
		p.distpos.push(dis);

		//Calcolo Distanza massima totale!
		if (dis > maxDistance) maxDistance = dis;
		//distanza massima in seno all'isola
		if (dis > islandStats[p.id].maxDistFromCenter) islandStats[p.id].maxDistFromCenter = dis;

	});

	if (rTComment)  console.log('tukaj');

	/**PREPARATION FOR AUDIO ETC */
	/**PREPARATION FOR AUDIO ETC */
	/**PREPARATION FOR AUDIO ETC */
	/**
	gloablcolor:
	{
	r,g,b,d (grey)
	dominant:[
		{ c,p,n } =>"r", posizione numerica colore (r:0,g:1..), numero di prime posizioni
	]
	colorComponent:[
		col : 'r'
		num: valore numerico del colore r->0, g->1...
		dev: scostamento dal colore
		minmaxdev: [min,max]
		minmaxval: [min,max] : in tutte le island i valori raggiunti del colore
	]
	
		
		
	}
	
	 */


	//DOPO AVER FATTO I minmax DELLE ISOLE SI INDIVIDUA IL COLORE DOMINANTE DELL?INTERA IMMMAGINE
	globalColor.dominant.sort((a, b) => b.n - a.n);

	/** Colore dominante intera immagine!! */
	let globalDominantColor = globalColor.colorComponent[globalColor.dominant[0].p]; //scelta del dominante in base alla posizione del colore dominate di tutta l'immagine!! 

	//	if (rTComment)  console.log('globalcolor', globalColor.dominant, globalColor, islandStats[0].colorComponent);

	/**Numero totale di elementi che compongono l'immagine (width*height) */
	let allElements = iData.dati.length;



	/**Calcolato in base alla percentuale sopra*/
	//	let audioMinimumNumberOfElements = Math.floor((minimumPercentageOfAcceptedNumberOfElements / 100) * allElements); //minimo di 5 elementi!!

	/**Counter di elementi audio attivi */
	let numberOfActiveAudio = 0;

	/**Stabiliamo la soglia per attivare l'audio dell'isola*/
	/**Stabiliamo la soglia per attivare l'audio dell'isola*/

	//AUDIO + MEDIE
	//AUDIO + MEDIE


	/**ACCORDI PER L'INTERA IMMAGINE */
	/**ACCORDI PER L'INTERA IMMAGINE */
	/**accordo in base al valore colore totale dominante */
	let dominantColorNormalizedValue = ((globalDominantColor.val - globalDominantColor.minmaxval[0]) / (globalDominantColor.minmaxval[1] - globalDominantColor.minmaxval[0]));

	/**posizione normalizzata del colore dominante dominant[x].p (r-0, g-1... )  */
	let dominantColorNormalizedPosition = globalColor.dominant[0].p / globalColor.dominant.length;

	/**posizione accordo */
	let chosenAccordPosition = Math.floor(dominantColorNormalizedValue * sound.Accordi.length); //posizione del valore in seno al minmax del grey

	/**Accordo scelto */
	let chosenAccord = sound.Accordi[chosenAccordPosition];

	/**inizio scala in base al valore sopra inverso!*/
	let chosenStartNote = Math.floor((1 - dominantColorNormalizedValue) * 12);

	/**recupera il pool in base alla percentale del colore dominante */
	let chosenPool = sound.instPools.getPoolsByNormalizedPosition(dominantColorNormalizedValue);

	//DEBUGGGG
	//DEBUGGGG

	//SCELTA DELLA LISTA DI STRUMENTI A DISPOSIZIONE!!

	chosenPool = sound.instPools.pools[0];
	//DEBUGGGG
	//DEBUGGGG

	if (rTComment)  console.log(`CHOSEN POOL: ${chosenPool.id} dominant p: ${globalColor.dominant[0].p} dominant normalized: ${dominantColorNormalizedPosition} Start note: ${chosenStartNote} Accord position: ${chosenAccordPosition}`)

	/** */



	/**ACCORDI PER L'INTERA IMMAGINE */
	/**ACCORDI PER L'INTERA IMMAGINE */

	/**Ultima Elaborazione per ogni isola! */
	islandStats.forEach(function(e, k) {

		/**raggruppa i valori globali immagine, che sono comuni a tutte le isole */
		e.global = {
			//Riferimento al global color
			color: globalColor,
			//valore normalizzato dell numero che contraddistingue la percentuale del colore dominante
			dominantColorNormalizedValue: dominantColorNormalizedValue,
			//valore notrmalizzato da 0-1 rapportato ai colori r->d (0->7)
			dominantColorNormalizedPosition: dominantColorNormalizedPosition,
			/**la scelta degli strumenti: pool in seno all'array degli strumenti pool*/
			instrumentPool: chosenPool,
			//inizio della starting nota per le sequenze etc.
			startNote: chosenStartNote,
			//Accordo globale - in base alla composizione dell'immagine
			accordPosition: chosenAccordPosition,
			//l'accordo scelto
			accord: sound.Accordi[chosenAccordPosition],
		}


		//Parte che si occupa della normalizzazione valore componentiColore in seno a valori max-min dello stesso
		e.colorComponent.forEach(function(p, k) {
			p.valnorm = (p.val - globalColor.colorComponent[p.num].minmaxval[0]) / (globalColor.colorComponent[p.num].minmaxval[1] - globalColor.colorComponent[p.num].minmaxval[0]);
		});

		//calcolo ed aggiunta numero normalizzato di elementi
		let normalizedNumberOfElements = e.normalizedNumberOfElements = (e.eln - minmaxNumberOfElements[0]) / (minmaxNumberOfElements[1] - minmaxNumberOfElements[0]);
		//nel caso max-min=0 (c'è solo un elemento per isola) aggiustiamo per non crashare la cosa
		if (Number.isNaN(normalizedNumberOfElements)) {
			normalizedNumberOfElements = e.normalizedNumberOfElements = 1;
		}

		/**raggruppiamo i valori rilevanti dell'isola: si sceglie il colore dominante dell'isola */
		e.isle = {
			normalizedNumberOfElements: normalizedNumberOfElements,
			normalizedSize: e.length, //numero elementi/elememnti totali dell'immagine  (tutti i quadrati)
			normalizedID: e.normid, // id normalizzato: id/tutale isole
			color: e.colorComponent[0], //il valore massimo che avevamo elaborato prima
			colorNormalizedPosition: e.colorComponent[0].num / e.colorComponent.length,
			colorDev: e.colorComponent[0].dev, //scostamento dal colore medio
			colorVal: e.colorComponent[0].val, //valore del colore

		};


		//NIENTE COLORE DOMINANTE IMMAGINE!! SCEGLIEREMO IN BASE ALLO SCOSTAMENTO DAL GREY
		//globalColor.colorComponent.sort((a, b) => b.dev - a.dev);


		//	throw "mona";



		//Durata e posizione in secondi dell'inizio del movimento
		//		e.wholeDuration = iData.duration; // durata in secondi del tutto
		e.wholeDuration = rTone.Transport.rPos.dur; // durata in secondi del tutto
		e.beginSeconds = e.wholeDuration * e.position[0]; //l'inizio di ciò che succederà all'oggetto è dato dalla sua posizione X
		e.endSeconds = e.beginSeconds + e.normalizedNumberOfElements; //calcolato il momento finale

		if (e.endSeconds > e.wholeDuration) //nel caso si vadi oltre la fine allora rischeduliamo l'inizio
		{
			let xx = e.endSeconds - e.wholeDuration;
			e.beginSeconds -= xx;
			e.endSeconds -= xx;
		}


		/*
		indirizzo al texdata che useremo come luogo dove mettere audio e video proprietà
		window.texData=texture che passa i parametri agli shader!!
		//js.array.slice fa una shallow copy swll'array: significa che recupera la referenza all'array, non copia i valori!!
		texAddress[0]: video active
		texAddress[1]: video data (valori rms!)
		texAddress[2]: audio active
		texAddress[3]: audio data (valori rms!)
		*/
		e.texVideoAddressActive = k * 4; //indirizzo in seno al texData
		e.texVideoAddressData = e.texVideoAddressActive + 1;
		e.texAudioAddressActive = e.texVideoAddressActive + 2;
		e.texAudioAddressData = e.texVideoAddressActive + 3;

		/** i dati che scaturiscono dal confronto con i dati webcam */
		e.video = {
			//ACTIVE e VALUE sono window.texData[e.texVideoActive...]
			/**
			js.array.slice fa una shallow copy swll'array: significa che recupera la referenza all'array, non copia i valori!!
			texRef[0]: video active
			texRef[1]: video data
			 */
			//attivo e valore saranno dati da e.texRef[0.1]
			/**il fattore di incremento per counters basati sul fragment duration!! più elementi ci sono più corto è lo step e lento sarà il movimento!!*/
			step: 1 / (5 * 60 + (e.normalizedNumberOfElements * 240)), //step: un sessantesimo di secondo (dura almeno un secondo) + lunghezza fino a 4 secondi in base al numero di elementi 
			counter: 0, /**il counter comincia una volta eccitato */
			dist: 0 /**distanza del pixel eccitato dal centro dell'isola */
		};


		/**Ogni isloa ha il suo strumento: può essere valido se è stato scelto ed attivato oppure no  */
		let audio = e.audio = {
			/**ci dice se l'audio dell'isola è attivato o meno*/
			active: false,
			/** ci notifica se l'audio ha suonato */
			hasPlayed: false,

			/** RANDOM PLAY, scattered in base al beat (posizione scattered / durata per avere il valore da 0->1)!!*/
			randomPlayStart: strumenti.scatterFloorTime(e.wholeDuration * Math.random(), 1, strumenti.rBeat) / e.wholeDuration,

			/** POSITION PLAY, scattered in base alla posizione (posizione scattered / durata per avere il valore da 0->1)!!*/
			positionPlayStart: strumenti.scatterFloorTime(e.wholeDuration * e.nrect[0], 1, strumenti.rBeat) / e.wholeDuration,

			/**segnaPosto interface per la funzione sotto ()*/
			autoPlay(t) { },
			/** resetta hasPlayed per permettere un replay! */
			autoPlayReset() { hasPlayed = false; }

		};

		if (rTComment)  console.log('RANDOM PLAY TIME', audio);

		/**AUDIO */
		/**AUDIO */
		//viene attivato solo per elementi maggiori del 0.8 percento, altrimenti il flag del texaoudio è negativo!

		//		if (normalizedNumberOfElements > .5) {
		//			e.inst = Object.create(synths.aSynth);
		//			let i = parseInt(18 + normalizedNumberOfElements * 30);
		//			//		i=parseInt(Math.random()*30+24);
		//			let nota = sound.noteNames[i];
		//			e.inst.init(e.id, nota, '8n');
		//			e.inst.setPan(e.ocenter);
		//			//audio pronto ad essere utilizzato!
		//			window.texData[e.texAudioAddressActive] = 0;
		//
		//			if (rTComment)  console.log('active audio', e.id, nota);
		//
		//		} else {
		//			//DISATTIVIAMO L'AUDIO, non serve altro poichè sarà ignorato!!
		//			window.texData[e.texAudioAddressActive] = -1;
		//		}
		//		if (rTComment)  console.log('nota', nota, i);
		/**AUDIO */
		/**AUDIO */


		/**FINE GO La funzione che fa andare avanti video etc. DA RICHIAMARE NEL RENDERER!!!*/
		/**FINE GO La funzione che fa andare avanti video etc. DA RICHIAMARE NEL RENDERER!!!*/
		/**Stabiliamo la soglia per attivare l'audio dell'isola*/
		/**Stabiliamo la soglia per attivare l'audio dell'isola*/

		/**percentuale di elementi ammessi (isole che hanno una percentuale di elementi maggiore di tot)*/
		let minimumPercentageOfAcceptedNumberOfElements = 0.2;

		//Attivato se supera una certa soglia di elementi!
		if (e.id == 1 || normalizedNumberOfElements > minimumPercentageOfAcceptedNumberOfElements) {

			/** SEQUENCERRRR */
			/** SEQUENCERRRR */
			let seq = Object.create(strumenti.RSequencer);

			/**IsleID, isle center position, adderss in audio texture, chosen instrument, starting note position, 
			repetitions, pause between repetitions, chosen accord (93 tutte le note) */

			//	se riusciamo ad inizializzare il sequencer si proceda
			if (seq.init(e)) {
				/**Attiviamo l'audio*/
				audio.active = true;

				/**incremento della variabile che indica il numero di strumenti audio attivi*/
				numberOfActiveAudio++;

				//			if (rTComment)  console.log('++++++++');
				e.sequencer = seq;

				/**Creiamo la funzione che setta le note dell'isola e fa suonare lo strumento!
				QUESTA È L'UNICA FUNZIONE CHE CI SERVE!!!!
				*/
				e.audio.play = () => {
					seq.play()
				}

				/** 
				AUTOPLAY: devi metterla nel render per far suonare autonomamente le isole.
				time flow t: da 0->1  
				
				controlla la posizione della coordinata texture del centro oggetto (0->1). Quando raggiunge t la fa suonare e disattiva per prossimi ! 
				
				 */
				e.audio.autoPlay = (t) => {
					//					if (audio.active && !e.audio.hasPlayed && e.texoc[0] < t) {
					if (audio.active && !e.audio.hasPlayed && e.audio.positionPlayStart < t) {
						e.audio.hasPlayed = true;
						seq.play();
					}

				}

				/**
				Basato sul valore di inizio random definito sopra, fa partire l'audio delle isole quando raggiorno il valore random
				 */
				e.audio.randomPlay = (t) => {
					if (audio.active && !e.audio.hasPlayed && e.audio.randomPlayStart < t) {
						e.audio.hasPlayed = true;
						seq.play();
					}
				}

				/** resetta hasPlayed per permettere un replay! */
				e.audio.autoPlayReset = () => {
					e.audio.hasPlayed = false;
				}
			}

			/** SEQUENCERRRR */
			/** SEQUENCERRRR */


		}

		/**Funzione che addolcisce la curva audio inizio veloce e finale lento, Dominio (x) da 0->1 */
		let smoothCurve = function(x) {
			const PI = 3.141592654;
			return 0.5 * Math.sin(PI * (Math.pow(4 * x, 0.5) - 0.5)) + 0.5;
		};
		/**++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
		/**++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
		/**++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
		/**++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
		/**++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
		/**++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

		/**GO La funzione che fa andare avanti video etc. DA RICHIAMARE NEL RENDERER!!!*/
		/**GO La funzione che fa andare avanti video etc. DA RICHIAMARE NEL RENDERER!!!*/
		e.go = function(t = -1) {
			/**VIDEO*/
			/**VIDEO*/
			//Il video è in gioco
			if (window.texData[e.texVideoAddressActive]) {
				window.texData[e.texVideoAddressData] = smoothCurve(e.video.counter);

				//if (rTComment)  console.log('e.go0:', e.id, e.texVideoAddressActive,window.texData[e.texVideoAddressData]);
				e.video.counter += e.video.step;
				if (e.video.counter > 1) { //concluso il counter, azzeriamo video attivo e counter;
					window.texData[e.texVideoAddressActive] = 0;
					window.texData[e.texVideoAddressData] = 0;
					e.video.counter = 0;
					//					if (rTComment)  console.log('e.go1', e.texVideoAddressActive);
				}
			}
			/**VIDEO*/
			/**VIDEO*/

			/**AUDIO AUTOPLAY*/
			/**AUDIO AUTOPLAY*/
			//			if (e.audio.active && t > 0) {
			//				e.audio.autoPlay(t)
			//			}
			/**AUDIO AUTOPLAY*/
			/**AUDIO AUTOPLAY*/

			/**AUDIO RANDOMPLAY*/
			/**AUDIO RANDOMPLAY*/
			if (e.audio.active) {

				if (t > 0) {
					e.audio.randomPlay(t);
					/**AUDIO OUTPUT */
					e.sequencer.output();
				}
			}
			/**AUDIO RANDOMPLAY*/
			/**AUDIO RANDOMPLAY*/

		}
		/**GO La funzione che fa andare avanti video etc. DA RICHIAMARE NEL RENDERER!!!*/
		/**GO La funzione che fa andare avanti video etc. DA RICHIAMARE NEL RENDERER!!!*/

		/**RESET AUDIO: PER FARLO SUONARE DI NUOVO! */
		/**RESET AUDIO: PER FARLO SUONARE DI NUOVO! */
		e.reset = () => {
			if (e.audio.active) {
				e.audio.autoPlayReset();
			}
		}
		/**RESET AUDIO: PER FARLO SUONARE DI NUOVO! */
		/**RESET AUDIO: PER FARLO SUONARE DI NUOVO! */

		//DATA TEXTURES FOR SHADERS
		//DATA TEXTURES FOR SHADERS
		//20 dati ISLANDS! 
		texf1.push(
			e.eln, //1-indica il numero di elementi 
			...e.ocenter, //3-centro isola

			//4
			...e.texoc, //2-centro isola in texture coordinate
			...e.position, 	//2-posizione relativa x, posizione relativa y,
			//8 
			...e.col 				//4-Medie colore, r,g,b,grey
			//12
		);

		//		if (k>2) throw 'Error2';
		const dx = e.orect[2] - e.orect[0];
		const dy = e.orect[3] - e.orect[1];

		//		if (rTComment)  console.log("Object n: "+k+" el.num: "+e.eln, e.ocenter, e.position);
		texf2.push(
			...e.db,				//2-medie Bright,Dark
			//2
			e.normalizedNumberOfElements, //1- indica proporzione di quadrati dell'isola vs. oggetto intero
			e.normid, //1- id normalizzato (da 0->1)
			//4
			parseInt(e.colorComponent[0].num), //COLORE DOMINANTE: 0->R 1->G 2->B  3->cyan 4->magenta 5->yellow 6->grey
			e.colorComponent[0].val, //valore del colore dominante
			//			e.beginSeconds / e.wholeDuration,		//inizio normalizzato
			//			e.endSeconds / e.wholeDuration,		//fine normalizzata

			e.maxDistFromCenter, //Distanza massima dal centro oggetto!!
			minmaxNumberOfElements[1]	//TODO massimo numero di elementi nelle isole menjaj to ki ne rabi!!
			//8
		);
		//		if (e.eln > 1000 || 1)
		//			if (rTComment)  console.log(parseInt(e.colorComponent[0].num)+ " Object n: " + k + " el.num: " + e.eln, minmaxNumberOfElements, e.normalizedNumberOfElements);
		texf3.push(
			...e.orect, //il rettangolo normale che racchiude l'oggetto!!  
			//4
			...e.nrect,//Rettangolo texture che racchiude oggetto 
			//8
			Math.random(), Math.random(), Math.random(), Math.random() //vec4 di random A,B,C,D per f(z)
			//12
			//
		);
		//END DATA TEXTURES FOR SHADERS
		//END DATA TEXTURES FOR SHADERS


	})


	if (rTComment)  console.log('oggetti: ' + islandStats.length + ' all: ' + id.length + ' minmaxNumberOfElements[1]: ' + minmaxNumberOfElements[1] + ' minmaxNumberOfElements[0]: ' + minmaxNumberOfElements[0], texf1.length, texf2.length, texf3.length);

	strumenti.rInstruments.initInstrumentsFromIsles(islandStats);


	//SUDDIVSIONE IN OGGETT GLES - PER OVVARE AL NUMERO MASSIMO DI PIXELS PER SHADER
	//SUDDIVSIONE IN OGGETT GLES - PER OVVIARE AL NUMERO MASSIMO DI PIXELS PER SHADER
	//ASSEGNAZIONE arrays per oggetto GL
	const pri = twgl.primitives; //gli fragments twgl

	let N = 0; //id oggetto
	let oggetto = []; //DA VEDERE se presenta problemi di persistenza

	//OGGETTI GLES - QUADRATONI DI PIXEL!!
	//OGGETTI GLES - QUADRATONI DI PIXEL!!

	//numero totale pixels
	let data_limit = iData.dati.length;
	let data_counter = 0;

	//Number of elements in the gles object: per ottimizzare il mesh la grandezza sarà congrua con la larghezza del rettangolo!
	//un chunck rettangolo quindi! ATTENTION! Devono esssere multipli di riga*2 per permettere i triangoli mesh

	//	NUMERO PIXELS NEL CHUNK, quadratoni
	let rows = 5;
	let index_limit = dx * rows;


	//calcolo che ci avviciniamo a un numero interessante
	while (index_limit < 1000 || index_limit <= data_limit) {
		rows += 1;
		index_limit = dx * rows;
	}

	//Aggiustiamo il data limit
	//	data_limit -= (dx + 1);
	index_limit = dx * 100;
	let index_counter = 0;

	//serve per non mettere troppi indici!
	let row_index_limit = index_limit - dx;

	//	iData.dati.every(function(p, key, arr) {

	for (let i = 0; i < iData.dati.length; i++) {

		let p = iData.dati[i];


		if (typeof oggetto[N] === "undefined") {
			oggetto[N] = {
				position: { numComponents: 3, data: new Array() }, 	// - coordinata xy del pixel, stride 3
				texcoord: { numComponents: 2, data: new Array() },	// - coordinata texture
				normal: { numComponents: 3, data: new Array() }, 	// - normale pixel
				indices: { numComponents: 3, data: new Array() },
				next1: { numComponents: 3, data: new Array() },	// il prossimo pixel, (per dot product etc.)
				next2: { numComponents: 3, data: new Array() },	// il prossimo pixel, (per dot product etc.)
				//---------------------------------------------------------------------
				id: { numComponents: 1, data: new Array() }, 	//	id dell'isola

				//distanza dal centro oggetto, gradiente y/x e z/x, distanza normalizzata in base a mezza diagonale intera immagine
				distpos: { numComponents: 4, data: new Array() }, //distanze del pixel->isle center, xyz: vettore, w: distanza
				colors: { numComponents: 4, data: new Array() },	//vec4 colori + grey
				brightdark: { numComponents: 2, data: new Array() } //vec4 dark, bright
			}
			//				if (rTComment)  console.log('zacetek', io, jo);

		}

		//Position
		oggetto[N].position.data.push(...p.pos);

		//Texture
		oggetto[N].texcoord.data.push(...p.tex);

		//distanze singoli pixel->centro oggetto
		oggetto[N].distpos.data.push(...p.distpos);

		//next: pixel vicino alla posizione (per dot products etc.)
		oggetto[N].next1.data.push(...p.next1); //distanza, posizione relativa
		oggetto[N].next2.data.push(...p.next2); //distanza, posizione relativa

		//island ID 
		oggetto[N].id.data.push(p.id);
		//Normal	
		oggetto[N].normal.data.push(...p.norm);

		//colors
		oggetto[N].colors.data.push(...p.normColor);

		//bright, dark: 2 ELEMENTI!!
		oggetto[N].brightdark.data.push(...p.normBrightDark);


		//INDICI
		//INDICI

		let a1, a2, a3;
		//controllo fine riga e fine oggetto

		let y = parseInt(index_counter / dx); //la colonna in cui siamo

		//contatore per la riga, per semplificare sotto
		let xcounter = (index_counter - y * dx) + 1;

		//		if (y < dy && index_counter < row_index_limit) {
		if ((index_counter < index_limit-dx) && data_counter < data_limit-dx) {
			//Schema mesh triangle strip: https://stackoverflow.com/questions/7011017/help-getting-vertex-indices-from-a-grid
			if (y & 1) {//odd row
				a1 = (y + 1) * dx - xcounter;
				a2 = (y + 2) * dx - xcounter;
				oggetto[N].indices.data.push(a1);
				oggetto[N].indices.data.push(a2);
//				if (rTComment)  console.log('index key odd', i, xcounter, a1, a2);
			} else {	//even
				a1 = index_counter;
				a2 = index_counter + dx;
				oggetto[N].indices.data.push(a1);
				oggetto[N].indices.data.push(a2);
//				if (rTComment)  console.log('index key even', i, xcounter, a1, a2);
			}
		} else {
			//			if (rTComment)  console.log('indexio index', data_counter, data_limit, index_counter, index_limit, row_index_limit, i);
//			if (rTComment)  console.log(' --- index key all', i, xcounter, a1, a2);
		}


		//
		//INDICI
		//INDICI
		//		
		index_counter++;
		data_counter++;

		//Arrivati alla fine dei dati assegnati per questo chunk resettiamo e continuiamo col prossimo!
		if (index_counter >= index_limit) { //teniamo conto del dato in più!
			//			if (rTComment)  console.log('indexio', data_limit, dx * dy, index_limit, a0, a1, a2, b0, b1, b2, data_counter);
//			if (rTComment)  console.log('indexio', data_counter, data_limit, dx * dy, index_counter, index_limit, row_index_limit, i);
			index_counter = 0; //aggiustiamo per arrivare a index_limit-1, per non sballare i numeri del chunk dati
			i-=dx;
			data_counter-=dx;
			N++;
		}
	}
	//	});
//	if (rTComment)  console.log('indexio end', data_counter, data_limit, dx * dy, index_counter, index_limit, row_index_limit);

	//END SUDDIVSIONE IN OGGETT GLES - PER OVVARE AL NUMERO MASSIMO DI PIXELS PER SHADER
	//END SUDDIVSIONE IN OGGETT GLES - PER OVVARE AL NUMERO MASSIMO DI PIXELS PER SHADER

	ret = (
		{
			/**La texture dati che conterrà i dati del singolo oggetto! [id * 36] */
			texData: texData,
			oggetti: oggetto, //oggetti/attributi per shaders!
			islands: islandStats, //statistiche oggetto

			/**Funzione che addolcisce la curva audio inizio veloce e finale lento 0->1 */
			audiocurve: function(x) {
				const PI = 3.141592654;
				return 0.5 * Math.sin(PI * (Math.pow(4 * x, 0.5) - 0.5)) + 0.5;
			},
			/** 
				DA RICHIAMARE NEL quad RENDERER
				prende la lista di id in entrata, proveniente dalla webcam e attiva i corrispettivi oggetti per giochi di 
				video e audio  
			 */
			wcData: function(idlist, crlist) {

				idlist.forEach(function(id, k) {
					let isle = islandStats[id]; //recuperata la corrispettiva isola
					//se il video dell''isola non è attivo lo attiviamo azzerando il contatore
					if (!texData[isle.texVideoAddressActive]) {
						texData[isle.texVideoAddressActive] = 1; //attivato il video

						//						isle.video.counter = 0; //azzerato il counter del video
					}
				});

				//CRLIST
				if (crlist.length > 2) {
					//individuata la posizione dell'isola nella texture
					let isle = islandStats[crlist[2]];
					//					if (rTComment)  console.log('isleid', isle.id);
					let isleVideoIdAddress = isle.texVideoAddressActive;
					//impostata come privilegiata
					if (texData[isleVideoIdAddress] < 2) {
						//se l'audio non è già attivo suoniamo lo instrumento
						if (isle.audio.active) {
							isle.audio.play();
						}
						texData[isleVideoIdAddress] = 2; //attivato il video come CR
					}
				}

			},

			/**
			DA RICHIAMARE IN SENO al rquad RENDERER: processa tutte le isole!
			t: prametro scorrere del tempo da 0->1; 1 fine della sequenza!
			 */
			go: function(t = -1) {
				islandStats.forEach(function(v, k) {
					v.go(t); //video-audio processing
				});
			},
			/**
			DA RICHIAMARE QUANDO ABBIAMO DA RESETTARE L'AUDIO: processa tutte le isole!
			 */
			reset() {
				islandStats.forEach(function(v, k) {
					v.reset(); //video-audio processing
				});
			},

			texf1: texf1, //dati formato texture
			texf2: texf2, //dati formato texture
			texf3: texf3, //dati formato texture
			info: {
				ow: w,  //larghezza dell'oggetto
				oh: h,	//altezza oggetto
				imageDiagonal: image_diagonal,
				numIslands: islandStats.length, //numero di isole
				minels: minmaxNumberOfElements[0], //minimo numero di elementi per isola
				maxels: minmaxNumberOfElements[1], //massimo numero di elementi per isola
				allels: allElements,
				maxDistance: maxDistance //massima distanza pixel->centro isola!
			}
		}
	);

	//	if (rTComment)  console.log(ret);

	//DEBUG
	//DEBUG
	// sendFile("p.gp", s);
	//DEBUG
	//DEBUG
	return ret;
}


/**
 * stabilisce quanto simile è un colore (col={r,g,b,a} all'altro in base alla tolleranza
 * ogni rapporto colore deve essere nel range, se uno esula non è simile!
 * 
 * 
 * rgb in formato 255,255,255 clamped uint8 per colore
 * @param {type} col0
 * @param {type} col1
 * @param {type} tolerance
 * @returns {undefined}
 */
function similar(col0, col1, tolerance) {
	let ret = true;
	let pc = [Math.abs(col0[0] - col1[0]), Math.abs(col0[1] - col1[1]), Math.abs(col0[2] - col1[2])];
	pc.every(function(c, i) {
		if (c / 255 > tolerance) {
			ret = false;
			return false;
		} else return true;
	});
	return ret;
}

function sendFile(filename, text) {
	let element = document.createElement('a');
	element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
	element.setAttribute('download', filename);

	element.style.display = 'none';
	document.body.appendChild(element);

	element.click();

	document.body.removeChild(element);
}


const math = {
	PI: 3.141592654, //  PI
	PI2: 1.570796327, // 1/2 PI
	PI3: 9.424777961, // 3*PI

	/** 
	funzione per ricavare la matrice di trasformazione della camera che si posizionerà attorno al targhet puntandolo
	
	camera: posizione della camera
	target: posizione del punto a cui si rivolge
	distance: la distanza dal punto
	alfa: angolo in direzione orizzontale
	beta: angolo in verticale
	gama: rotazione attorno al proprio asse (direzione su)
	*/
	orbit: (camera, target, distance, alfa, beta, gama) => {

	}

}

function flattenPreAllocated(arr) {
	let numElementsUptoIndex = Array(arr.length);
	numElementsUptoIndex[0] = 0;
	for (let i = 1; i < arr.length; i++)
		numElementsUptoIndex[i] = numElementsUptoIndex[i - 1] + arr[i - 1].length;
	let flattened = new Array(numElementsUptoIndex[arr.length - 1] + arr[arr.length - 1].length);
	let skip;
	for (let i = 0; i < arr.length; i++) {
		skip = numElementsUptoIndex[i];
		for (let j = 0; j < arr[i].length; j++)
			flattened[skip + j] = arr[i][j];
	}
	return flattened;
}

/** Shuffles an array */
function ashuffle(arr) {
	for (var i = arr.length - 1; i > 0; i--) {
		var j = Math.floor(Math.random() * (i + 1));
		var temp = arr[i];
		arr[i] = arr[j];
		arr[j] = temp;
	}
	return arr;
}

export {
	getImageData,
	rand,
	randElement,
	sendFile,
	ashuffle,
	r_pictures, //la lista delle immagini upload
	math		//utilità e funzioni matematiche
};

